import type { TrendResult } from "@/lib/conditions/trend";

type Props = {
  trend: TrendResult | null;
};

const STYLES: Record<string, { arrow: string; colour: string }> = {
  improving: { arrow: "↑", colour: "text-emerald-600 bg-emerald-50" },
  steady: { arrow: "→", colour: "text-text-muted bg-warm-bg" },
  deteriorating: { arrow: "↓", colour: "text-amber-600 bg-amber-50" },
  peaking: { arrow: "★", colour: "text-gold bg-gold/10" },
};

export function TrendBadge({ trend }: Props) {
  if (!trend) return null;

  const style = STYLES[trend.direction];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-semibold ${style.colour}`}
      aria-label={`Conditions ${trend.label.toLowerCase()}`}
    >
      <span aria-hidden>{style.arrow}</span>
      {trend.label}
    </span>
  );
}
